var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "64", height: "64", viewBox: "0 0 64 64" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("path", { fill: "#E1F7F7", d: "M53.14 45.14c12.227-12.227 14.465-29.813 5-39.28-9.467-9.465-27.053-7.227-39.28 5s-14.465 29.813-5 39.28c9.467 9.465 27.053 7.227 39.28-5z" }),
      React.createElement("path", { fill: "#4AABB0", d: "M17 4c2.831 0 5.32 3.034 6.741 7.611 2.05.49 4.108 2.055 5.455 4.389 1.467 2.541 1.724 5.355.89 7.444C33.718 26.37 36 30.598 36 35.3c0 8.837-8.059 16-18 16s-18-7.163-18-16c0-4.008 1.658-7.673 4.398-10.48A8.956 8.956 0 0 1 3 20c0-4.428 3.198-8.11 7.411-8.86C11.854 6.826 14.267 4 17 4z" }),
      React.createElement(
        "g",
        { fill: "#015E61" },
        React.createElement("path", { d: "M18 35a2 2 0 0 1 2 2v25a2 2 0 1 1-4 0V37a2 2 0 0 1 2-2z" }),
        React.createElement("path", { d: "M12 62a2 2 0 0 1 2-2h8a2 2 0 1 1 0 4h-8a2 2 0 0 1-2-2zM16.828 48.657l2.829-2.829-8.485-8.485-2.829 2.829z" }),
        React.createElement("path", { d: "M19.172 48.657l-2.829-2.829 8.485-8.485 2.829 2.829z" })
      ),
      React.createElement("path", { fill: "#018489", d: "M40 46h4l-5.772 17.316a1 1 0 0 1-.949.684h-1.892a1 1 0 0 1-.948-1.316L40 46zM56 46h-4l5.772 17.316a1 1 0 0 0 .949.684h1.892a1 1 0 0 0 .948-1.316L56 46z" }),
      React.createElement("path", { fill: "#015E61", d: "M63 54a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H33a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h30zm-4-8a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H37a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1h22z" }),
      React.createElement("path", { fill: "#018489", d: "M24 26a2 2 0 1 1 0 4 2 2 0 0 1 0-4zM11 16a3 3 0 1 1 0 6 3 3 0 0 1 0-6z" }),
      React.createElement("circle", { cx: "48", cy: "16", r: "6", fill: "#FFF" })
    )
  );
});